export const normalizeNumberField = value => {
  const matched = `${value}`.match(/(-)?(\d){0,}(\.|,)?(\d)?/);
  return matched ? matched[0].replace(/,/, '.') : '';
};
